import React, { useRef } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/index";
import Button from "../UI/Button";
import "./Login.css";

const Login = () => {
    const emailRef = useRef();
    const passwordRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const token = useSelector(state => state.auth.token);
    const emailId = useSelector(state => state.auth.emailId);
    const submitHandler = (e) => {
        e.preventDefault();
        const enteredEmail = emailRef.current.value;
        const enteredPassword = passwordRef.current.value;
        const url = "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyAOZUEl1VEtJpHQ36BjgMWcd-VLnjkHSSQ";
        fetch(url, {
            method: "POST",
            body: JSON.stringify({
                email: enteredEmail,
                password: enteredPassword,
                returnSecureToken: true
            }),
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
                if (res.ok)
                    return res.json();
                else {
                    return res.json().then((data) => {
                        throw new Error(data.error.message);
                    })
                }
            })
            .then((data) => {
                dispatch(authActions.login({
                    token: data.idToken,
                    emailId: enteredEmail
                }));
                localStorage.setItem("token", data.idToken);
                localStorage.setItem("email", enteredEmail);
                history.replace("/home");
                window.location.reload();
            })
            .catch((err) => window.alert(err.message));
    }
    return (
        <div>
            <form className="login" onSubmit={submitHandler}>
                <h2>Login</h2>
                <label htmlFor="Email">Email</label>
                <input type="text" name="Email" placeholder="Email" ref={emailRef} required />
                <label htmlFor="Password">Password</label>
                <input type="password" name="Password" placeholder="Password" ref={passwordRef} required />
                <div className="auth">
                    <NavLink to="/forget-password" className="btn btn-primary">
                        Forget Password?
                    </NavLink>
                    <Button className="btn-primary">Login</Button>
                </div>
                <h3>Don't have an account ? SignUp</h3>
            </form>
        </div>);
}

export default Login;